<template>
  <section class="end-container">
    <div class="bg-container pic-full">
      <div class="title-container pic-full" :class="lang"></div>
      <div
        class="button-container pic-full flex-center"
        :class="mouseDown ? 'down' : 'normal'"
        @mousedown="mouseDown = true"
        @mouseup="mouseDown = false"
        @touchstart="mouseDown = true"
        @touchend="mouseDown = false"
        @click="toUrl('open', homeLang.head[0].url)"
      >
        <span>{{ homeLang.end.start }}</span>
        <div class="enter-container pic-full"></div>
      </div>
      <!-- <div class="xswap pic-full"></div> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'end',
  data() {
    return {
      mouseDown: false
    };
  },
  props: {
    homeLang: {
      type: Object
    }
  }
};
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .end-container {
    .bg-container {
      width: 11.52rem;
      height: 3.97rem;
      margin: 0.02rem auto 0;
      background-image: url('../../assets/pc/end/banner.png');
      position: relative;
      > div {
        position: absolute;
      }
      .title-container {
        &.zh {
          background-image: url('../../assets/pc/end/title.png');
          width: 4.96rem;
          height: 0.68rem;
          left: 1.2rem;
          top: 1.57rem;
        }
        &.en {
          background-image: url('../../assets/pc/end/title_en.png');
          width: 5.14rem;
          height: 0.78rem;
          left: 1.2rem;
          top: 1.59rem;
        }
      }
      .button-container {
        cursor: pointer;
        width: 3.9rem;
        height: 0.9rem;
        right: 1.28rem;
        top: 1.54rem;
        &.normal {
          background-image: url('../../assets/pc/button.png');
        }
        &.down {
          background-image: url('../../assets/pc/button_down.png');
          span {
            transform: translate(0.04rem, 0.04rem);
          }
          .enter-container {
            transform: translate(0.04rem, 0.055rem);
          }
        }
        span {
          font-size: 0.24rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #ffffff;
        }
        .enter-container {
          width: 0.27rem;
          height: 0.22rem;
          margin-left: 0.15rem;
          background-image: url('../../assets/pc/enter.png');
          transform: translateY(0.015rem);
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .end-container {
    .bg-container {
      width: 7.5rem;
      height: 2.82rem;
      margin: -0.14rem auto 0;
      background-image: url('../../assets/mobile/end/banner.png');
      position: relative;
      > div {
        position: absolute;
      }
      .title-container {
        &.zh {
          width: 3.51rem;
          height: 0.48rem;
          left: 0.62rem;
          top: 1.12rem;
          background-image: url('../../assets/mobile/end/title.png');
        }
        &.en {
          width: 3.51rem;
          height: 0.454em;
          left: 0.62rem;
          top: 1.15rem;
          background-image: url('../../assets/mobile/end/title_en.png');
        }
      }
      .xswap {
        width: 0.25rem;
        height: 0.27rem;
        left: 0.76rem;
        top: 1.91rem;
        background-image: url('../../assets/mobile/end/xswap.png');
      }
      .button-container {
        cursor: pointer;
        width: 2.76rem;
        height: 0.64rem;
        right: 0.49rem;
        top: 1.09rem;
        &.normal {
          background-image: url('../../assets/pc/button.png');
        }
        &.down {
          background-image: url('../../assets/pc/button_down.png');
          span {
            transform: translate(0.03rem, 0.03rem);
          }
          .enter-container {
            transform: translate(0.03rem, 0.04rem);
          }
        }
        span {
          font-size: 0.18rem;
          font-family: PingFangSC, PingFangSC-Regular;
          color: #ffffff;
        }
        .enter-container {
          width: 0.19rem;
          height: 0.15rem;
          margin-left: 0.15rem;
          background-image: url('../../assets/mobile/enter.png');
          transform: translateY(0.01rem);
        }
      }
    }
  }
}
@media screen and (max-width: 374px) {
  .end-container {
    .button-container {
      span {
        transform: scale(0.8);
        // width: 125%;
      }
    }
  }
}
</style>
